import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import ReactCountryFlag from 'react-country-flag';

function LangFlag({ code, active, label, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={label}
      aria-pressed={active}
      className={`flex items-center justify-center w-9 h-9 rounded-full border transition-all duration-200 ${
        active
          ? 'border-rose-900 bg-white shadow-sm'
          : 'border-stone-200 opacity-55 hover:opacity-100 hover:border-stone-400'
      }`}
    >
      <ReactCountryFlag
        countryCode={code}
        svg
        aria-hidden="true"
        style={{ width: '1.35em', height: '1.35em' }}
        title={label}
      />
    </button>
  );
}

export default function Header({ lang, setLang }) {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const t = {
    login: lang === 'de' ? 'Anmelden' : 'Sign in',
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 bg-[#faf7f4] transition-shadow duration-300 ${
        scrolled ? 'shadow-md' : 'shadow-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <a href="/" className="flex items-center gap-0 select-none">
            <span className="text-2xl font-black tracking-tight text-stone-900">
              Model
            </span>
            <span className="text-2xl font-black tracking-tight text-rose-900">
              Camp
            </span>
          </a>

          <div className="hidden md:flex items-center gap-4">
            <div className="flex items-center gap-1.5">
              <LangFlag
                code="GB"
                active={lang === 'en'}
                label="English"
                onClick={() => setLang('en')}
              />
              <LangFlag
                code="CH"
                active={lang === 'de'}
                label="Schweiz"
                onClick={() => setLang('de')}
              />
            </div>

            <a
              href="/s"
              className="px-5 py-2 rounded-lg border-2 border-stone-900 text-stone-900 font-semibold text-sm hover:bg-stone-900 hover:text-white transition-all duration-200"
            >
              {t.login}
            </a>
          </div>

          <button
            className="md:hidden p-2 rounded-lg text-stone-600 hover:text-rose-900 transition-colors"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            {mobileOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-[#faf7f4] border-t border-stone-200 px-4 py-4 flex flex-col gap-3">
          <div className="flex items-center gap-1.5">
            <LangFlag
              code="GB"
              active={lang === 'en'}
              label="English"
              onClick={() => {
                setLang('en');
                setMobileOpen(false);
              }}
            />
            <LangFlag
              code="CH"
              active={lang === 'de'}
              label="Schweiz"
              onClick={() => {
                setLang('de');
                setMobileOpen(false);
              }}
            />
          </div>
          <a
            href="/s"
            className="px-5 py-2.5 rounded-lg border-2 border-stone-900 text-stone-900 font-semibold text-sm text-center hover:bg-stone-900 hover:text-white transition-all duration-200"
          >
            {t.login}
          </a>
        </div>
      )}
    </header>
  );
}
